<template>
    <div class="col-sm-9 mx-auto">
        <div class="container mt-2">
            <b-button
                @click="goToCreateshipment()"
                size="sm"
                style="margin-right: 5px;"
                name="goToCreateShipment"
                >Create Shipment</b-button
            >

            <b-button size="sm" style="margin-right: 5px;" @click="goToCreateInvoice()"
                >Create Invoice</b-button
            >

            <input type="file" ref="file" style="display: none" />
            <b-button size="sm" style="margin-right: 5px;" @click="goToUploadDocument()"
                >Upload file</b-button
            >

            <b-button
                v-if="isAdminOrSuperUser"
                size="sm"
                style="margin-right: 5px;"
                @click="goToSalesPriceAndAccount()"
                >Set Sales Price And Account</b-button
            >
        </div>
      
      <div class="container-fluid mt-1">
        <b-row>
          <b-col class="center">
            <label class="mt-2" style="margin-left: 350px; font-size: 13px">Tracking Number:</label>
          </b-col>
          <b-col>
            <b-form-input
                class="center ml-5"
                style="margin-right: 300px; width: 250px; height: 30px"
                id="trackingNumber"
                v-model="getTrackingNumber"
                disabled
            />
          </b-col>
        </b-row>
      </div>

        <div class="row mt-2">
            <div class="col-sm-12">
                <iframe
                    class="iframe"
                    v-bind:src="getLabelUrl"
                    width="100%"
                    height="700px"
                    name="shipmentLabelUrl"
                ></iframe>
            </div>
        </div>
        <setPriceLinesModal ref="displayPriceLinesModal" :shipmentId="getShipmentId" :linkId="getLinkId" />
    </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import { ACTIONS, CORE_PREFIX } from '../store/constants';
export default {
    components:{
        setPriceLinesModal: () => import('../components/History/Actions/setPriceLinesAction')
    },
    data() {
        return {
            file: ''
        };
    },
    mounted() {
        this.$store.dispatch(CORE_PREFIX + ACTIONS.CORE.SET_LOADING, false);
        if (this.getLabelUrl === '') {
            this.$router.push('/');
        }
    },
    methods: {
        goToUploadDocument() {
            this.$router.push('UploadShipmentDocuments');
        },
        goToCreateshipment() {
            this.$router.push('Createbooking');
        },
        goToSalesPriceAndAccount() {
            this.$refs['displayPriceLinesModal'].showAddPriceLinesModal();
        },
        goToCreateInvoice() {
            this.$router.push({ name: 'invoice', params: { shipmentId: this.getShipmentId, linkId: this.getLinkId } });
        }
    },
    computed: {
        ...mapGetters('createShipment', ['getLabelUrl', 'getTrackingNumber']),
        ...mapGetters('core', ['getShipmentId', 'getBaseUrl', 'isAdminOrSuperUser', 'getLinkId'])
    }
};
</script>
<style scoped>
.center {
  margin: auto;
  width: 50%;
}
</style>